/**
 * Модуль инициализации inputMask.
 * Находим элемент по селектору и инициализируем его
 */
itsoftApp.createModule('inputMaskInit', ['inputMaskLibrary'], function () {
    // Локальные переменные
    let module = this;

    const inputMaskInit = function () {
        itsoftApp.modules.inputMaskLibrary.callback('.js-input-mask');
    };

    inputMaskInit();
    module.callback = inputMaskInit;
});
